import { Skeleton } from "@mui/material";
import { StyledTableCell, StyledTableRow } from "./styles";

interface IProps {
  cells: number;
}

const TableSkeleton = ({ cells }: IProps) => {
  return (
    <StyledTableRow>
      {[...Array(cells)].map((_, i) => (
        <StyledTableCell key={i} component="th" scope="row">
          <Skeleton />
        </StyledTableCell>
      ))}
    </StyledTableRow>
  );
};

export default TableSkeleton;
